import createMetas from './createMetas';

export const DEFAULT_OG_SITE_NAME = 'Spotahome';
export const DEFAULT_OG_LOCALE = 'en_US';

const DEFAULT_PROPERTIES = {
  siteName: DEFAULT_OG_SITE_NAME,
  locale: DEFAULT_OG_LOCALE
};

const PROPERTIES_MAP = {
  title: 'fb:title',
  appId: 'fb:app_id',
  url: 'fb:url',
  imageUrl: 'fb:image',
  siteName: 'fb:site_name',
  locale: 'fb:locale',
  description: 'fb:description'
};

export const createFacebookMetas = (props = {}) =>
  createMetas(props, DEFAULT_PROPERTIES, PROPERTIES_MAP);

export default {
  createFacebookMetas,
  DEFAULT_OG_SITE_NAME,
  DEFAULT_OG_LOCALE
};
